import { Error, Lock, LockOpen, Schedule, Warning } from '@sparkpost/matchbox-icons';

export const TLS_STATUS_CONFIG = {
  valid: {
    color: 'green',
    icon: Lock,
    label: 'Valid',
    tooltip: 'This domain has a valid TLS certificate'
  },
  pending: {
    color: 'blue',
    icon: Schedule,
    label: 'Pending',
    tooltip: 'Certificate provisioning in progress. This may take several minutes'
  },
  unknown: {
    color: undefined,
    icon: LockOpen,
    label: 'Inactive',
    tooltip: 'Managed TLS is not enabled for this domain.'
  },
  unavailable: {
    color: 'red',
    icon: Error,
    label: 'Unavailable',
    tooltip: 'A TLS certificate cannot be issued for this domain.',
    isError: true
  },
  failed: {
    color: 'red',
    icon: Error,
    label: 'Failed',
    tooltip: 'Certificate provisioning failed. Please review the error and try again.',
    isError: true
  },
  expired: {
    color: 'yellow',
    icon: Warning,
    label: 'Expired',
    tooltip: 'Certificate expired. Renewal is in progress'
  }
};

// Error code specific configurations
// Provides error descriptions displayed next to the badge
export const ERROR_CODE_CONFIG = {
  'acme:unauthorized': {
    description:
      'Certificate provisioning failed due to authorization issues. Please verify your domain and try again.'
  },
  'acme:dns': {
    description: 'Please make sure the domain has a valid CNAME record.'
  },
  'acme:rejected_identifier': {
    description: 'A TLS certificate cannot be issued for this domain.'
  },
  'acme:temporary': {
    description: "Certificate provisioning might take longer due to instabilities in Let's Encrypt."
  },
  'service:internal': {
    description:
      'Certificate provisioning failed due to an internal error. Please contact support for assistance.'
  },
  unknown: {
    description:
      'Certificate provisioning failed due to an internal error. Please contact support for assistance.'
  }
};
